import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { EmptyState } from 'components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from "react-router-dom";
import TeacherSet from './TeacherSet';
import EditIcon from '@material-ui/icons/Edit';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));
let mounted = false;

const LessonTeachers = props => {
  const { className, reload, ...rest } = props;
  const model = useSelector(state => state.models.lesson);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    if (mounted) setOpenEdit(true);
  };

  const handleEditClose = () => {
    if (mounted) setOpenEdit(false);
  };

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  }, []);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Lesson Teachers" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            {model.teachers.map((teacher, index) => (
              <TableRow key={index}>
                <TableCell className={classes.header}>
                  <div>{teacher.name_en}</div>
                  <div><Typography variant="caption">{teacher.title}</Typography></div>
                </TableCell>
                <TableCell align="right">
                  <Button color="primary" component={RouterLink} size="small" to={`/teachers/${teacher.id}/summary`} variant="outlined">
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      <EmptyState active={!model.teachers.length} message="No teachers assigned." />
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <TeacherSet onClose={handleEditClose} reload={reload} open={openEdit} model={model} />
    </Card>
  );
};

LessonTeachers.propTypes = {
  className: PropTypes.string,
};

export default LessonTeachers;
